import {mapActions, mapState, mapWritableState} from 'ui.vue3.pinia'
import {menuStore} from './store'
import {UnitBody} from './UnitBody'

export const MainItem = {
    props: {
        item: Object,
        index: Number
    },
    components: {
        UnitBody
    },
    computed: {
        ...mapState(menuStore, ['isMobile']),
        ...mapWritableState(menuStore, ['parent']),
        cssClass() {
            let result = [];
            if (this.item.isShow) {
                result.push('open')
            }
            result.push('item-' + this.index)
            return result;
        },
        cssClassItem() {
            return {
                highlightMenu: this.item.isShow && this.parent !== this.item,
                prev: this.parent === this.item
            }
        }
    },
    methods: {
        ...mapActions(menuStore, ['closeMenu']),
        open(e) {
            if (this.isMobile) {
                e.preventDefault()
            }
            this.closeMenu()
            this.item.isShow = true
            this.parent = null
            this.item.children.forEach(ar2Item => ar2Item.isShow = false)
            if (this.item.col5) {
                this.item.col5.forEach(item => item.isShow = true)
            }

        },
        openDesktop() {
            //TODO: придумать как упростить, код повторяется 3 раза
            if (this.isMobile) {
                return
            }
            this.closeMenu();
            this.item.isShow = true;
        },
        closeDesktop() {
            if (this.isMobile) {
                return
            }
            this.closeMenu();
        },
    },
    template: `
    <div @mouseleave="closeDesktop" class="header-nav-main-unit" :class="cssClass">
        <div class="header-nav-main-unit-title" :class="cssClassItem" @click="open" @mouseenter="openDesktop">
            <a :href="item.href">{{item.text}}</a>
        </div>
          <transition name="fade">
            <UnitBody v-if="item.isShow" :ar1Item="item"></UnitBody>
          </transition>
    </div>
    `
}